import { useCallback } from 'react'

import {
  SanityShouldDisplayContextBasedContentOptions,
  useSanityContextBasedContent,
} from './useSanityContextBasedContent'
import {
  SanityShouldDisplayRoleBasedContentOptions,
  useSanityRoleBasedContent,
} from './useSanityRoleBasedContent'

export interface UseSanityRoleAndContextBasedContent {
  isLoading: boolean
  shouldDisplayContent: (
    options: SanityShouldDisplayRoleBasedContentOptions &
      SanityShouldDisplayContextBasedContentOptions,
  ) => boolean
}

export type SanityShouldDisplayRoleAndContextBasedContent = (
  options: SanityShouldDisplayRoleBasedContentOptions &
    SanityShouldDisplayContextBasedContentOptions,
) => boolean

export const useSanityRoleAndContextBasedContent = (): UseSanityRoleAndContextBasedContent => {
  const { shouldDisplayContent: shouldDisplayForContext } = useSanityContextBasedContent()
  const { isLoading, shouldDisplayContent: shouldDisplayForRole } = useSanityRoleBasedContent()

  const shouldDisplayContent = useCallback(
    (subMenuEntry) => shouldDisplayForContext(subMenuEntry) && shouldDisplayForRole(subMenuEntry),
    [shouldDisplayForContext, shouldDisplayForRole],
  )

  return { isLoading, shouldDisplayContent }
}
